import { render, staticRenderFns } from "./mProject.vue?vue&type=template&id=02b5081a&scoped=true"
import script from "./mProject.vue?vue&type=script&lang=js"
export * from "./mProject.vue?vue&type=script&lang=js"
import style0 from "./mProject.vue?vue&type=style&index=0&id=02b5081a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b5081a",
  null
  
)

export default component.exports